import { Button, ExpandIcon, ShareIcon } from '@ui/kit';
import { useToggleState } from '@utils/react';
import { BuilderLightbox } from '../../../../modals/builder-lightbox.js';
import { courseBuilderStore } from '../../../../state/store.js';
import { BlockList } from './block-list.js';
import { wrapperCls, buttonsContainerCls, buttonContentCls } from './content.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Content(props) {
  const [showBuilder, builderActions] = useToggleState(false);
  const openShareDrawer = () => {
    courseBuilderStore.dispatch(courseBuilderStore.actions.toggleShareDrawer(true));
  };
  return /*#__PURE__*/jsxs("div", {
    ref: props.ref,
    className: wrapperCls,
    children: [/*#__PURE__*/jsx(BlockList, {
      course: props.course
    }), /*#__PURE__*/jsxs("div", {
      className: buttonsContainerCls,
      children: [/*#__PURE__*/jsx(Button, {
        theme: "secondary",
        onClick: builderActions.enable,
        children: /*#__PURE__*/jsxs("div", {
          className: buttonContentCls,
          children: [/*#__PURE__*/jsx(ExpandIcon, {
            height: 15
          }), " Tilpas forl\xF8b"]
        })
      }), /*#__PURE__*/jsx(Button, {
        theme: "primary",
        onClick: openShareDrawer,
        children: /*#__PURE__*/jsxs("div", {
          className: buttonContentCls,
          children: [/*#__PURE__*/jsx(ShareIcon, {
            className: "shareIcon",
            height: 20
          }), " Del forl\xF8b"]
        })
      })]
    }), /*#__PURE__*/jsx(BuilderLightbox, {
      active: showBuilder,
      course: props.course,
      onClose: builderActions.disable
    })]
  });
}

export { Content };
//# sourceMappingURL=content.js.map
